import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)

/**
 * TeamMembersSlider functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class TeamMembersSlider {
  /**
     * Constructs a new TeamMembersSlider instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-prev-btn"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-next-btn"]')
    this.teamMembers = this.element.querySelectorAll('.swiper-slide .team-member')
    this.slides = this.element.querySelectorAll('.swiper-slide')
    this.mediaQuery = window.matchMedia('(min-width: 1024px)')

    if (this.slides.length == 1) {
      this.element.classList.add('has-single-slide')
    }

    const teamSlider = new Swiper(this.swiperElement, {
      loop: false,
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 30,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      autoHeight: true,
    })

    this.teamMembers.forEach((teamMember) => {
      const hiddenText = teamMember.querySelector('.hidden-text')
      const moreBtn = teamMember.querySelector('.more-button .more')
      const lessBtn = teamMember.querySelector('.more-button .less')
      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          this.swiperWrapper.style.height = 'auto'
          this.hideHiddenText(this.teamMembers)
          teamMember.classList.add('show-hidden-text')
        })
      }
      if (lessBtn) {
        lessBtn.addEventListener('click', () => {
          this.hideHiddenText(this.teamMembers)
          teamSlider.updateAutoHeight()
          if (!document.body.classList.contains('single-treatment')) {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
            }
          } else {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
            }
          }
        })
      }
    })

    teamSlider.on('slideChange', () => {
      if (!document.body.classList.contains('single-treatment')) {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
        }
      } else {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
        }
      }
      this.hideHiddenText(this.teamMembers)
    })
  }

  hideHiddenText (teamMembers) {
    this.teamMembers.forEach((teamMember) => {
      teamMember.classList.remove('show-hidden-text')
    })
  }

}
